var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWeatherThunderstormProb = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 22,
  fill: "none",
  viewBox: "0 0 20 22.002"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  d: "M10.677 11.002H4a4 4 0 1 1 0-8h1.416a5.001 5.001 0 0 1 9.484 1h1.6a3.5 3.5 0 1 1 0 7h-4.129L11.6 13.94h1.93c.177 0 .339.106.419.27a.54.54 0 0 1-.039.528l-4.806 7.058a.47.47 0 0 1-.38.206.5.5 0 0 1-.205-.05.515.515 0 0 1-.248-.588l1.13-4.302H7.47a.47.47 0 0 1-.419-.27.54.54 0 0 1 .039-.527z",
  clipRule: "evenodd"
})));
export default SvgWeatherThunderstormProb;